import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  content: {
    description: 'Insurance coverage warning message about carrier support being discontinued',
    defaultMessage:
      "Additional insurance coverage by carriers will no longer be supported with ShipStation Carrier Services. Switch to ParcelGuard's lower-cost coverage in one click. <a>Go to Automation Rules</a>",
    id: '/83KDU',
  },
});
